export default __webpack_public_path__ + "static/media/terms.0f58968b.pdf";